// popup global variables

import { ConnectedRouter } from 'connected-react-router/immutable';
import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { isScreenWidthMobile } from '../app/components/custom-hooks/screen-detector';
import { postData } from '../common/api';
import {
  checkAtcPopupOffersAndStoreData,
  createPopupOfferRequest,
  getMuseVariantFromEvent,
  getSelectorForProductForm,
  getVariantsWithQuantityForSpecificShop,
} from '../common/apiRequest';
import { generateString } from '../common/strings';
import {
  changeCartVariants,
  changeCartVartiantWithoutProperties,
  getCurrencyFromShopifyCart,
  getVariantsQuantityFromCart,
  increaseQuantityAndGetMrCartForVariantsWithQuantity,
  updateProductIDsInCartForPrimary,
} from '../common/cart';
import { getOfferEndpoint } from '../common/constants';
import { logger } from '../common/logger';

import { getDevice, getShop, isInaEss } from '../common/pageData';
import {
  getOfferID,
  getOrderID,
  setFloatingInDisplay,
  setOfferID,
  setOrderID,
  getFLoatingInDisplay,
  getOffersDisable,
  getFloating,
  setMrActiveOffer,
  getIsShopifyFunctionsEnabled,
  getWindoKey,
} from '../common/settings';

import history from '../app/utils/history';
import Init from '../app/containers/Init';
import { GlobalStyle } from '../app/components/skins';
import HomePage from '../app/containers/HomePage';
import { continueEvent, serializeFormToJSON } from '../common/html';

import { getMerchantSpecificThemeFlags } from '../app/components/helpers/offer';
import { getCustomerId } from '../common/offerData';
import { sleep } from '../common/time';

function getPopupProps({ theme, offerType }) {
  if (!theme) {
    return {};
  }

  const { popupDesktopLayoutType, popupType } = theme;
  const out = {
    popupHeight: '800px',
    popupWidth: '444px',
    isSlideOut: true,
  };

  if (offerType === 'bundle') {
    return out;
  }

  const isMobile = isScreenWidthMobile();

  // central compact desktop
  if (!isMobile) {
    if (popupType === 'central' && popupDesktopLayoutType === 'compact') {
      out.popupHeight = '550px';
      out.popupWidth = '770px';
      out.isSlideOut = false;
    }

    if (popupType === 'central' && popupDesktopLayoutType === 'fullpage') {
      out.popupHeight = '550px';
      out.popupWidth = '770px';
      out.isSlideOut = false;
    }
  }
  return out;
}

export function renderInDiv(props) {
  logger.log('render popup');
  const start = performance.now();
  // const { products } = props;
  const el = document.getElementById('mr-div-12');
  if (el) {
    // const THEME = createTheme({
    //   typography: {
    //     fontFamily: props.theme && props.theme.font,
    //   },
    // });
    const popupProps = getPopupProps({
      theme: props.theme,
      offerType: props.offerType,
    });

    const themeWithMerchantSpecificFlags = getMerchantSpecificThemeFlags({
      shopURL: getShop(),
      theme: props.theme || {},
      offerType: `popup-${props.offerType}`,
    });

    ReactDOM.render(
      // <MuiThemeProvider theme={THEME}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div>
            <Init />
            <GlobalStyle {...props.theme} {...popupProps} />
            {!props.close && (
              <HomePage
                mrOfferID={props.mrOfferID}
                products={props.products}
                open={props.open}
                expand={props.expand}
                primary={props.primary}
                loadingOffer={props.loadingOffer}
                theme={themeWithMerchantSpecificFlags}
                timer={props.timer}
                trigger={props.trigger}
                eventID={props.eventID}
                cart={props.cart}
                isTimerDisabled={props.isTimerDisabled}
                isDiscountDisabled={props.isDiscountDisabled}
                event={props.event}
                variantsWithOldQuantity={props.variantsWithOldQuantity}
                triggerType={props.triggerType}
                floatingDisabled={props.floatingDisabled}
                offerType={props.offerType}
                currencyFormat={props.currencyFormat}
                discountType={props.discountType}
                discountValue={props.discountValue}
                discountQuantity={props.discountQuantity}
                offerLevelDiscountQuantity={props.offerLevelDiscountQuantity}
                isDiscountQuantityRestricted={
                  props.isDiscountQuantityRestricted
                }
                isNumberOfOfferedProductsRestricted={
                  props.isNumberOfOfferedProductsRestricted
                }
                isDiscountCodeApplicable={props.isDiscountCodeApplicable}
                changeCartVartiantWithoutProperties={
                  changeCartVartiantWithoutProperties
                }
                isDisableOfferOnClose={props.isDisableOfferOnClose}
                checkoutOnSkip={props.checkoutOnSkip}
                isBrandingEnabled={props.isBrandingEnabled}
                priceRoundType={props.priceRoundType}
                discountRoundType={props.discountRoundType}
                variantsWithQuantityFromPdp={props.variantsWithQuantityFromPdp}
              />
            )}
          </div>
        </ConnectedRouter>
      </Provider>,
      el,
    );

    logger.Debug(performance.now() - start, 'render time');
  } else {
    const x = document.getElementsByTagName('BODY')[0];
    const elem = document.createElement('div');
    elem.setAttribute('id', 'mr-div-12');
    x.appendChild(elem);
    renderInDiv(props);
  }
}

export async function addedToCart(
  cart,
  trigger,
  event,
  eventID,
  variantsWithQuantity,
) {
  const variantsWithOldQuantity = getVariantsQuantityFromCart(
    variantsWithQuantity,
    cart,
  );

  const offerRequest = {};
  if (cart) {
    const { token } = cart;
    offerRequest.cart_token = token;
  }
  offerRequest.variantsWithQuantity = variantsWithQuantity;
  if (variantsWithQuantity.length > 0) {
    offerRequest.cart = increaseQuantityAndGetMrCartForVariantsWithQuantity(
      cart,
      variantsWithQuantity,
    );
  }

  offerRequest.currency = getCurrencyFromShopifyCart(cart);
  offerRequest.source = trigger === 'atc' ? 'add_to_cart' : 'buy_now';
  offerRequest.device = getDevice();
  offerRequest.mr_order_id = getOrderID();
  offerRequest.mr_offer_id = getOfferID();
  offerRequest.customerId = getCustomerId();
  offerRequest.popupTriggerType = 'product';

  await getAndDisplayOffer(
    offerRequest,
    trigger,
    event,
    eventID,
    variantsWithQuantity,
    variantsWithOldQuantity,
  );
}

async function getAndDisplayOffer(
  req,
  trigger,
  event,
  eventID,
  variantsWithQuantity,
  variantsWithOldQuantity,
) {
  const response = await postData(getOfferEndpoint(), req);
  if (!response) {
    return;
  }

  setOrderID(response.order_id);
  if (response.is_eligible === true) {
    const {
      offer: { offered },
    } = response;
    setMrActiveOffer(response.offer);
    setOfferID(response.offer.mr_offer_id);

    if (variantsWithQuantity.length > 0) {
      req.cart = updateProductIDsInCartForPrimary({
        cart: req.cart,
        variantsWithQuantity: response.offer.variantsWithQuantity,
      });
    }

    setFloatingInDisplay(true);
    renderInDiv({
      products: offered,
      open: true,
      expand: true,
      mrOfferID: response.offer.mr_offer_id,
      primary: response.offer.primary,
      loadingOffer: false,
      theme: response.offer.theme,
      isTimerDisabled: response.offer.isTimerDisabled,
      isDiscountDisabled: response.offer.isDiscountDisabled,
      timer: response.offer.timer,
      trigger,
      eventID,
      cart: req.cart,
      event,
      variantsWithOldQuantity,
      triggerType: response.offer.triggerType,
      floatingDisabled: response.offer.floatingDisabled,
      offerType: response.offer.type,
      currencyFormat: response.offer.currencyFormat,
      discountType: response.offer.discountType,
      discountValue: response.offer.discountValue,
      discountQuantity: response.offer.discountQuantity,
      isDiscountQuantityRestricted: response.offer.isDiscountQuantityRestricted,
      isNumberOfOfferedProductsRestricted:
        response.offer.isNumberOfOfferedProductsRestricted,
      isDiscountCodeApplicable: response.offer.isDiscountCodeApplicable,
      isDisableOfferOnClose: response.offer.isDisableOfferOnClose,
      checkoutOnSkip: false,
      isBrandingEnabled: response.offer.isBrandingEnabled,
      priceRoundType: response.offer.priceRoundType,
      discountRoundType: response.offer.discountRoundType,
      offerLevelDiscountQuantity: response.offer.offerLevelDiscountQuantity,
    });

    await onPopupOfferEligible({ offer: response.offer });
  } else {
    if (variantsWithQuantity.length > 0) {
      await changeCartVariants(variantsWithOldQuantity);
    }
    if (['herbn-eden.myshopify.com'].includes(getShop())) {
      // the atc doesn't reflect immediately so added a delay
      await sleep(500);
    }
    continueEvent(event, trigger);
  }
}

export async function changeCartAndContinue(
  event,
  variantsWithQuantity,
  trigger,
) {
  if (trigger !== 'c' && trigger !== 'cp') {
    if (variantsWithQuantity.length > 0) {
      await changeCartVariants(variantsWithQuantity);
    }
  }

  if (!event.target) {
    return;
  }
  console.log('changeCartAndContinue', event, trigger);
  continueEvent(event, trigger);
}

export function getVariantIDFromTarget(target) {
  // getProductPropertiesFromTarget(target);
  const closestForm = target.closest('form');
  if (!closestForm) {
    // doesn't have a form this store
    if (getShop() === 'selvrys-store.myshopify.com') {
      const variantElements = document.getElementsByName('id');
      for (const variantElement of variantElements) {
        if (variantElement.value) {
          return variantElement.value;
        }
      }
    }
    return;
  }
  const idElement = closestForm.querySelector('[name="id"],[name="id[]"]');
  if (!idElement) {
    return;
  }
  const variantId = idElement.value;
  if (!isNaN(Number(variantId))) {
    return variantId;
  }
}

export function getVariantsWithQuantityFromForm(closestForm) {
  try {
    const formdata = new FormData(closestForm);
    const formJSON = {};
    formdata.forEach((value, key) => {
      if (!Reflect.has(formJSON, key)) {
        formJSON[key] = value;
        return [];
      }
      if (!Array.isArray(formJSON[key])) {
        formJSON[key] = [formJSON[key]];
      }
      formJSON[key].push(value);
    });

    // no id
    if (!Reflect.has(formJSON, 'id')) {
      return [];
    }

    let ids = formJSON.id;
    if (!Array.isArray(ids)) {
      ids = [ids];
    }

    let quantities = formJSON.quantity;
    if (!quantities) {
      quantities = [];
      for (let i = 0; i < ids.length; i++) {
        quantities = quantities.concat(i > 0 ? 0 : 1);
      }
    } else if (!Array.isArray(quantities)) {
      quantities = [quantities];
    }

    const properties = getProductPropertiesFromForm(closestForm);
    const variantsWithQuantity = ids.reduce((items, item, idx) => {
      if (Number(quantities[idx]) > 0) {
        const itemData = {
          sp_variant_id: Number(item),
          quantity: Number(quantities[idx]),
        };
        if (properties) {
          itemData.properties = properties;
        }
        return items.concat(itemData);
      }
      return items;
    }, []);

    return variantsWithQuantity;
  } catch (e) {
    return [];
  }
}

export function getSelectedVariantIdFromURL() {
  const variantIdMatch = window.location.search.match(
    /.*variant=([^&|\n|\t\s]+)/,
  );
  if (variantIdMatch) {
    return variantIdMatch[1];
  }
  return 0;
}

export function getDefaultProductVariant(product) {
  if (product) {
    if (product.variants) {
      if (product.variants.length > 0) {
        return product.variants[0].id;
      }
    }
  }
}

export function getProductPropertiesFromTarget(target) {
  const closestForm = target.closest('form');
  return getProductPropertiesFromForm(closestForm);
}

export function getProductPropertiesFromForm(closestForm) {
  // logger.log('closest form', closestForm);
  if (!closestForm) {
    return {};
  }

  const formData = serializeFormToJSON(closestForm);
  const { properties } = formData;
  if (properties) {
    return properties;
  }
  return {};
}
export function getVariantsWithQuantityFromEvent(event) {
  const { target } = event;
  try {
    if (
      [
        'at-tempo.myshopify.com',
        'shoptikidemo.myshopify.com',
        'car-touchup-paint.myshopify.com',
      ].includes(getShop())
    ) {
      const specificVariantsWithQuantity = getVariantsWithQuantityForSpecificShop(
        {
          target,
        },
      );
      if (specificVariantsWithQuantity.length > 0) {
        return specificVariantsWithQuantity;
      }
    }

    let closestForm = target.closest('form');
    if (!closestForm) {
      // doesn't have a form this store
      if (getShop() === 'selvrys-store.myshopify.com') {
        const variantElements = document.getElementsByName('id');
        for (const variantElement of variantElements) {
          if (variantElement.value) {
            return [
              { sp_variant_id: Number(variantElement.value), quantity: 1 },
            ];
          }
        }
      }

      if (getShop() === 'muse-india.myshopify.com') {
        const variantID = getMuseVariantFromEvent(event);

        if (variantID) {
          return [{ sp_variant_id: Number(variantID), quantity: 1 }];
        }
      }

      if (getShop() === 'theodinvediko.myshopify.com') {
        const variantID = target.getAttribute('data-id');
        if (variantID) {
          return [{ sp_variant_id: Number(variantID), quantity: 1 }];
        }
      }

      if (
        [
          'bluetyga.myshopify.com',
          'kalaonlineshaz.myshopify.com',
          'longevitybox.myshopify.com',
          'drocto.myshopify.com',
          'lilacst.myshopify.com',
        ].includes(getShop())
      ) {
        closestForm = document.querySelector("form[action$='/cart/add']");
      }

      // try getting from closest button
      const closestButton = target.closest('button');
      if (closestButton) {
        const { dataset } = closestButton;
        if (dataset) {
          const { variantId } = dataset;
          if (variantId) {
            return [{ sp_variant_id: Number(variantId), quantity: 1 }];
          }
        }
      }

      if (getShop() === 'hydropeptidedev.myshopify.com') {
        if (closestButton) {
          const { nextElementSibling } = closestButton;
          if (nextElementSibling && nextElementSibling.tagName === 'FORM') {
            closestForm = nextElementSibling;
          }
        }
      }

      if (!closestForm) {
        return [];
      }
    }
    return getVariantsWithQuantityFromForm(closestForm);
  } catch (e) {
    return [];
  }
}

let store = null;
export const setStore = st => {
  store = st;
};

export const init = () => {
  const mrUpsellConfig = getWindoKey('mrUpsellConfig');
  const { productFormSelector } = mrUpsellConfig;
  const selector = getSelectorForProductForm({ productFormSelector });
  const closestForm = document.querySelector(selector);
  if (mrUpsellConfig && closestForm) {
    checkAtcPopupOffersAndStoreData({
      closestForm,
      trigger: 'atc',
    });
  }
};

export async function getOfferAndDisplayOnCartPageInit() {
  try {
    // if floating is in display or checkout is disabled then don't check for offers
    const checkOfffer =
      !getFLoatingInDisplay() &&
      !getOffersDisable('checkout') &&
      getFloating() !== 'true';
    if (!checkOfffer) return;

    // this is enabled only for specific stores
    if (!isInaEss()) {
      return;
    }

    const offerReq = await createPopupOfferRequest('cart');

    const response = await postData(getOfferEndpoint(), offerReq);
    if (!response) {
      return;
    }

    if (response.is_eligible === true) {
      const { offered } = response.offer;
      setOrderID(response.order_id);
      setOfferID(response.offer.mr_offer_id);
      setFloatingInDisplay(true);

      renderInDiv({
        products: offered,
        open: true,
        expand: true,
        mrOfferID: response.offer.mrOfferID,
        primary: response.offer.primary,
        loadingOffer: false,
        theme: response.offer.theme,
        isTimerDisabled: response.offer.isTimerDisabled,
        isDiscountDisabled: response.offer.isDiscountDisabled,
        timer: response.offer.timer,
        trigger: 'cp',
        eventID: generateString(5),
        cart: offerReq.cart,
        event: {},
        triggerType: response.offer.triggerType,
        floatingDisabled: response.offer.floatingDisabled,
        offerType: response.offer.type,
        currencyFormat: response.offer.currencyFormat,
        discountType: response.offer.discountType,
        discountValue: response.offer.discountValue,
        discountQuantity: response.offer.discountQuantity,
        isDiscountQuantityRestricted:
          response.offer.isDiscountQuantityRestricted,
        isNumberOfOfferedProductsRestricted:
          response.offer.isNumberOfOfferedProductsRestricted,
        isDiscountCodeApplicable: response.offer.isDiscountCodeApplicable,
        isDisableOfferOnClose: response.offer.isDisableOfferOnClose,
        checkoutOnSkip: false,
        isBrandingEnabled: response.offer.isBrandingEnabled,
        priceRoundType: response.offer.priceRoundType,
        discountRoundType: response.offer.discountRoundType,
        offerLevelDiscountQuantity: response.offer.offerLevelDiscountQuantity,
      });

      await onPopupOfferEligible({ offer: response.offer });
    }
  } catch (e) {
    logger.log(e.message);
  }
}

// function to be called whenever an popup offer is eligible
export async function onPopupOfferEligible({ offer }) {
  // if functions is enabled then store data
  if (getIsShopifyFunctionsEnabled()) {
    const sfModule = await import('./shopifyFunctionsDiscount');
    sfModule.storeShopifyFunctionsOfferData({ offer });
  }
}
